import { Button, Card, Typography, Select, MenuItem, InputLabel, FormControl, LinearProgress, Checkbox, Grid, Box, Dialog, DialogTitle, DialogContent, ButtonBase, IconButton, Paper } from '@mui/material';
import React, { Component } from 'react'
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import RGL, { WidthProvider, Responsive } from "react-grid-layout";
import "./style.css";
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { AppProperties, IsPublicSite } from '../../../common/functions';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import 'react-loading-skeleton/dist/skeleton.css'
import { MdDragIndicator } from "react-icons/md";
import SFDonutChart from '../SFCharts/Donut/SFDonutChart';
import SFLineChart from '../SFCharts/Line/SFLineChart';
import DueAssignmentWidget from './widgets/DueAssignmentWidget';
import AssignmentListWidget from './widgets/AssignmentListWidget';
import { BeatLoader } from 'react-spinners';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { isMobile } from 'react-device-detect';
import { NotificationManager } from 'react-notifications';
import { AppContext } from '../../../AppContext';
import RecommendForPracticeWidget from './widgets/RecommendForPracticeWidget';
import ActionResultPopup from '../../../components/ActionResultPopup';
import { FaCartShopping } from "react-icons/fa6";
import SFPracticeSetCart from '../SFPerformanceAnalytics/components/SFPracticeSetCart';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PerformanceWidget from './widgets/PerformanceWidget';
import PracticeSetsWidget from './widgets/PracticeSetsWidget';
import ApiRequestService from '../../../components/ApiRequestService';
import SFStudentSearch from '../../SFComponents/SFStudentSearch/SFStudentSearch';
import { LuGlasses } from "react-icons/lu";
import SFCourseSectionEnrollDialog from '../../SFComponents/SFCourseSectionEnrollDialog/SFCourseSectionEnrollDialog';
import SkillsWidget from './widgets/SkillsWidget';
import SFPublicSkillsLibrary from '../../SFComponents/SFPublicSkillsLibrary';


const ResponsiveReactGridLayout = WidthProvider(Responsive);

class SFDashboard extends Component {

    appProperties = AppProperties();

    static contextType = AppContext

    previousContext = null;

    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            layouts: [
                { i: "assignment-due-card", x: 0, y: 0, w: 4, h: 3, minW: 4, maxW: 4 },
                { i: "recommend-for-practice", x: 4, y: 0, w: 3, h: 3, minW: 4, maxW: 4 },
                { i: "assignments-card", x: 7, y: 0, w: 5, h: 3, minW: 4, maxW: 4 },
                { i: "performance-widget", x: 0, y: 3, w: 6, h: 4, minW: 6 },
                { i: "practice-widget", x: 6, y: 3, w: 6, h: 4, minW: 6 },
                // { i: "semester-overview-card", x: 4, y: 0, w: 5, h: 6, minW: 4, maxW: 4 },
                // { i: "calendar-card", x: 9, y: 0, w: 3, h: 3, minW: 4, maxW: 4 },
                // { i: "practice-card", x: 9, y: 0, w: 3, h: 3, minW: 4, maxW: 4 },
            ],
            courses: [],
            allCourses: [],
            showCourseEnroll: false,
            selectedCourseEnroll: null,
            selectedSectionEnroll: null,
            sections: [],
            selectedCourse: null,
            // selectedCourse: null,
            assignments: [],
            coursesOverview: [],
            isActionResultPopupOpen: false,
            selectedCourseEnrollName: null,
            selectedSectionEnrollName: null,
            loadingEnroll: false,
            isInstructor: false,
            isStudentMode: false,
            newPracticeAssignment: null,

            // instructor can view student dashboard
            instructorCourses: [],
            instructorSections: [],
            instructorStudents: [],
            selectedInstructorCourse: null,
            selectedInstructorSectionID: null,
            selectedStudentUserName: null,
            selectedStudentFullName: null,

            showSkillsLibrary: false,
        }
    }

    componentDidMount() {

        if (this.appProperties && this.appProperties.currentUserData && this.appProperties.currentUserData.role != "0") {
            this.setState({
                isInstructor: true,
            })
            if (this.context?.studentMode === undefined || this.context?.studentMode === null || this.context?.studentMode === false) {
                this.getInstructorCourses();
            }
        }

        this.getStudentCourses();
        // this.getSemesterOverview();
    }


    componentDidUpdate(prevProps, prevState) {
        if (this.state.isInstructor && prevState.isStudentMode !== this.context?.studentMode) {
            console.debug("REFRESHED>>??");
            this.getInstructorCourses();
            this.setState({
                selectedInstructorCourse: null,
                selectedInstructorSectionID: null,
                selectedStudentUserName: null,
                selectedStudentFullName: null,
                isStudentMode: this.context?.studentMode
            });
        }
    }


    getStudentCourses() {
        this.setState({
            showCourseEnroll: false
        })
        const responsePromise = ApiRequestService({
            method: "POST",
            url: "/getStudentSectionEnrollment",
        });

        responsePromise.then(res => {
            if (res && res.data && res.data.data && res.data.data.enrollmentData) {
                this.setState({
                    courses: res.data.data.enrollmentData
                })
                if (res.data.data.enrollmentData && res.data.data.enrollmentData.length) {
                    let firstCourse = res.data.data.enrollmentData[0];
                    this.setState({
                        selectedCourse: firstCourse
                    })
                    if (this.context && this.context.updateStudentEnrolledCourses && this.context.selectedCourse === null) {
                        this.context.updateStudentEnrolledCourses(res.data.data.enrollmentData);
                    }
                } else {
                    this.getAllCourses();
                }
            } else {
                this.getAllCourses();
            }
        }).finally(() => {
            this.setState({
                loading: false,
            })
        })
    }

    getAllCourses() {
        this.setState({
            showCourseEnroll: true
        })
        const responsePromise = this.props.apiService({
            method: 'post',
            url: '/getAllCoursesEnroll'
        })
        responsePromise.then(res => {
            if (res && res.data && res.data.data) {
                this.setState({
                    allCourses: res.data.data.course_names.filter(course => course.status === 1),
                })
            }
        })
    }

    getSections(course_id) {
        const payload = {
            course_id: course_id
        }
        this.props.apiService({
            method: 'post',
            url: '/getAllSectionsEnroll',
            data: payload
        }).then(res => {
            var tempSectionArr = res.data.data.section_names;
            if (tempSectionArr != null) {
                this.setState({
                    sections: tempSectionArr,
                });
            }
        })
    }

    addMappingService(payload) {
        this.setState({ loadingEnroll: true });
        let responsePromise = this.props.apiService({
            method: 'post',
            url: '/addStudentSectionEnrollment',
            data: payload
        });
        responsePromise.then(res => {
            if (res.data.message !== null && res.data.message !== "") {
                if (res.data.message.toLowerCase().indexOf("duplicate") >= 0) {
                    NotificationManager.error("Duplicate entry. Section already Enrolled", "Error", 4000);
                } else if (res.data.message.indexOf("MaxSectionLimitReached") >= 0) {
                    NotificationManager.error("You cannot enroll in more than one section for every course", "Error", 4000);
                }
                else {
                    NotificationManager.error(res.data.message, "Error", 4000);
                }
            } else {
                this.getStudentCourses();
                this.setState({ isActionResultPopupOpen: true }) // Show the success popup
            }
        }).finally(() => {
            this.setState({ loadingEnroll: false });
        });
    }


    onLayoutChange(layout) {
        this.props.onLayoutChange(layout);
    }

    handleTakeQuizURL = (assignment) => {

        // TODO: Probably will change the takequiz name
        let url = `/takequiz?quiz_id=${assignment.quizID || assignment.quiz_id}&course_id=${assignment.courseID || assignment.course_id}&section_id=${assignment.sectionID || assignment.section_Id}&quiz_name=${assignment.quizName || assignment.quiz_name}&quiz_type=${assignment.quiz_type}&course_name=${selectedCourse?.course_name}`

        this.props.handleRoute(url)
    }

    handleCloseActionResultPopup = () => {
        this.setState({
            isActionResultPopupOpen: false,
            selectedCourseEnrollName: null,
            selectedSectionEnrollName: null,
        })
    }

    getLayouts = (selectedCourse) => {
        let newLayouts = [];
        /*  if (selectedCourse === null || selectedCourse === undefined) {
             newLayouts = [
                 { i: "assignment-due-card", x: 0, y: 0, w: 4, h: 3, minW: 4, maxW: 4 },
                 { i: "assignments-card", x: 4, y: 0, w: 8, h: 3, minW: 4, maxW: 4 },
                 { i: "performance-widget", x: 0, y: 3, w: 6, h: 4, minW: 6 },
                 { i: "practice-widget", x: 6, y: 3, w: 6, h: 4, minW: 6 },
             ]
             return newLayouts;
         } */

        if (this.state.isInstructor && !this.state.isStudentMode) {
            if (this.state.selectedInstructorCourse && this.state.selectedInstructorCourse.enable_practice_and_performance === 0) {
                newLayouts = [
                    { i: "assignment-due-card", x: 0, y: 0, w: 4, h: 3, minW: 4, maxW: 4 },
                    { i: "assignments-card", x: 4, y: 0, w: 8, h: 3, minW: 4, maxW: 8 },
                ]
            } else if (this.state.selectedInstructorCourse && this.state.selectedInstructorCourse.enable_practice_and_performance === 2) {
                newLayouts = [
                    { i: "assignment-due-card", x: 0, y: 0, w: 4, h: 3, minW: 4, maxW: 4 },
                    { i: "recommend-for-practice", x: 4, y: 0, w: 3, h: 3, minW: 4, maxW: 4 },
                    { i: "assignments-card", x: 7, y: 0, w: 5, h: 3, minW: 4, maxW: 4 },
                    { i: "performance-widget", x: 0, y: 3, w: 6, h: 4, minW: 6 },
                    { i: "practice-widget", x: 6, y: 3, w: 6, h: 4, minW: 6 },
                ]
            }

            console.debug("newLayouts>>??", newLayouts, this.state.isInstructor, this.state.isStudentMode)
            return newLayouts;
        }

        // console.debug("selectedCourse>>??", selectedCourse)

        if (selectedCourse) {
            if (selectedCourse.enable_practice_and_performance === 0) {
                newLayouts = [
                    { i: "assignment-due-card", x: 0, y: 0, w: 4, h: 3, minW: 4, maxW: 4 },
                    { i: "assignments-card", x: 4, y: 0, w: 8, h: 3, minW: 4, maxW: 8 },
                ]
            } else if (selectedCourse.enable_practice_and_performance === 2) {
                newLayouts = [
                    { i: "assignment-due-card", x: 0, y: 0, w: 4, h: 3, minW: 4, maxW: 4 },
                    { i: "recommend-for-practice", x: 4, y: 0, w: 3, h: 3, minW: 4, maxW: 4 },
                    { i: "assignments-card", x: 7, y: 0, w: 5, h: 3, minW: 4, maxW: 4 },
                    { i: "performance-widget", x: 0, y: 3, w: 6, h: 4, minW: 6 },
                    { i: "practice-widget", x: 6, y: 3, w: 6, h: 4, minW: 6 },
                ]
            }

            if (this.appProperties && this.appProperties.isLTIStudent) {
                newLayouts = [
                    { i: "performance-widget", x: 0, y: 0, w: 6, h: 4, minW: 6 },
                    { i: "practice-widget", x: 6, y: 0, w: 6, h: 4, minW: 6 },
                    { i: "recommend-for-practice", x: 0, y: 4, w: 3, h: 3, minW: 4, maxW: 4 },
                ];
            }
        }


        return newLayouts;

        if (selectedCourse.enable_practice_and_performance === 0 || selectedCourse.enable_practice_and_performance === 1) {
            newLayouts = [
                { i: "assignment-due-card", x: 0, y: 0, w: 4, h: 3, minW: 4, maxW: 4 },
                { i: "assignments-card", x: 4, y: 0, w: 8, h: 3, minW: 4, maxW: 4 },
                { i: "performance-widget", x: 0, y: 3, w: 6, h: 4, minW: 6 },
                { i: "practice-widget", x: 6, y: 3, w: 6, h: 4, minW: 6 },
            ]
        } else {
            newLayouts = [
                { i: "assignment-due-card", x: 0, y: 0, w: 4, h: 3, minW: 4, maxW: 4 },
                { i: "recommend-for-practice", x: 4, y: 0, w: 3, h: 3, minW: 4, maxW: 4 },
                { i: "assignments-card", x: 7, y: 0, w: 5, h: 3, minW: 4, maxW: 4 },
                { i: "performance-widget", x: 0, y: 3, w: 6, h: 4, minW: 6 },
                { i: "practice-widget", x: 6, y: 3, w: 6, h: 4, minW: 6 },
            ]
        }

        // hide the Due assignment and List of all assignment widgets if its an LTI Student
        if (this.appProperties && this.appProperties.isLTIStudent) {
            newLayouts = [
                { i: "performance-widget", x: 0, y: 0, w: 6, h: 4, minW: 6 },
                { i: "practice-widget", x: 6, y: 0, w: 6, h: 4, minW: 6 },
                { i: "recommend-for-practice", x: 0, y: 4, w: 3, h: 3, minW: 4, maxW: 4 },
            ];
        }

        console.debug("newLayouts>>>", newLayouts)

        return newLayouts;
    }

    onSavePracticeSet = (data) => {
        this.setState({
            newPracticeAssignment: data,
        })
    }


    handleCourseSelect = (event) => {
        let courseID = event.target.value;
        let selectedCourse = this.state.instructorCourses.find(course => course.course_id === courseID)
        // console.debug("selectedCourse>>??", selectedCourse)
        this.setState({
            selectedInstructorCourse: selectedCourse,
            selectedStudentUserName: null,
            selectedStudentFullName: null,
            selectedInstructorSectionID: null,
        })
        this.getInstructorCourseSections(courseID);
    }

    getInstructorCourses = () => {
        ApiRequestService({
            method: 'post',
            url: '/getAllCourses'
        }).then(res => {
            console.debug('course response ', res);

            if (res && res.data && res.data.data) {
                this.setState({
                    instructorCourses: res.data.data.course_names,
                })
            } else {
                if (res.data.message !== null && res.data.message !== '') {
                    NotificationManager.error(res.data.message, 'ERROR', 3000);
                }
            }
        });
    }
    getInstructorCourseSections = (courseID) => {
        ApiRequestService({
            method: 'post',
            url: '/getAllSections',
            data: {
                course_id: courseID,
            }
        }).then(res => {
            console.debug('sections response ', res);

            if (res && res.data && res.data.data) {
                this.setState({
                    instructorSections: res.data.data.section_names,
                })
            } else {
                if (res.data.message !== null && res.data.message !== '') {
                    NotificationManager.error(res.data.message, 'ERROR', 3000);
                }
            }
        });
    }

    getInstructorCourseSectionStudents = (courseID, sectionID) => {
        ApiRequestService({
            method: 'post',
            url: '/getAllStudentEnrollmentByID',
            data: {
                course_id: courseID,
                section_id: sectionID,
            }
        }).then(res => {
            console.debug('students response ', res);

            if (res && res.data && res.data.data) {
                this.setState({
                    instructorStudents: res.data.data,
                })
            } else {
                if (res.data.message !== null && res.data.message !== '') {
                    NotificationManager.error(res.data.message, 'ERROR', 3000);
                }
            }
        });
    }

    getSteps = (courseToUse, cpanelCourseUrl) => {
        return (
            <Paper className='instructions-container' elevation={4}>
                <p><strong>To open this widget for students, please follow these steps:</strong></p>
                <ol style={{ paddingLeft: '20px', marginTop: '8px', gap: "6px" }} className='d-flex flex-column'>
                    <li>Open the <a href={cpanelCourseUrl} target="_blank" rel="noopener noreferrer">course link</a>.</li>
                    <li>Enable <strong>Assignment Practice</strong> for this section (<strong>{courseToUse.section_name}</strong>).</li>
                    <li>Return to this page and refresh it to view the widget.</li>
                </ol>
            </Paper>
        )
    }

    render() {
        let { courses } = this.state;
        const { selectedCourse, onAddActivityLog,
            selectedCategories, handleAddCategory, handleRemoveCategory
        } = this.context;

        if (this.state.loading) {
            return <LoadingSpinner />
        }

        let courseToUse = null;
        let grayedOut = false;
        let cpanelCourseUrl = "";

        if (!this.state.isInstructor) { // Student account
            courseToUse = { ...selectedCourse };
        } else if (this.state.isInstructor && !this.state.isStudentMode) { // Instructor (not in student mode)
            courseToUse = this.state.selectedInstructorCourse;
        } else if (this.state.isInstructor && this.state.isStudentMode) { // Instructor in student mode
            courseToUse = { ...selectedCourse };

            const tempEnablePractice = selectedCourse?.enable_practice_and_performance;
            courseToUse = { ...selectedCourse, enable_practice_and_performance: 2 };
            if (tempEnablePractice !== undefined && tempEnablePractice !== 2) {
                grayedOut = true;
                //sections?course_id=80&course_name=1%20Physics%201200%20Spring%202025%20Columbus%20Campus&is_lti_enabled=false
                let hostname = window.location.hostname;
                if (hostname === 'localhost') {
                    hostname = 'http://localhost:3000'
                } else {
                    hostname = "https://" + hostname.replace("student", "cpanel");
                }
                cpanelCourseUrl = `${hostname}/sections?course_id=${courseToUse.course_id}&course_name=${courseToUse.course_name}&is_lti_enabled=${courseToUse.for_lti_practice}`;
            }
        }
        // console.debug("grayedOut>>??", grayedOut, cpanelCourseUrl)

        let layouts = this.getLayouts(courseToUse);
        console.debug("this.context.isSpecialCourse", this.context.isSpecialCourse)
        if (layouts && this.context.isSpecialCourse) {
            layouts = [
                {
                    "i": "skills-widget",
                    "x": 0,
                    "y": 0,
                    "w": 4,
                    "h": 3,
                    "minW": 4,
                    "maxW": 4
                },
                {
                    "i": "recommend-for-practice",
                    "x": 4,
                    "y": 0,
                    "w": 3,
                    "h": 3,
                    "minW": 3,
                    "maxW": 3
                },
                {
                    "i": "practice-widget",
                    "x": 7,
                    "y": 3,
                    "w": 5,
                    "h": 3,
                    "minW": 6
                },
                {
                    "i": "performance-widget",
                    "x": 0,
                    "y": 3,
                    "w": 6,
                    "h": 4,
                    "minW": 6
                },
            ]
            console.debug("layouts>>??", layouts);
        }

        return (
            <div className='sf-dashboard-container'>
                {this.state.isInstructor && !this.context?.studentMode ?
                    <div className="instructor-in-student-mode">
                        <div className='instructor-in-student-mode-footer'>
                            <LuGlasses fontSize={20} />
                            <span className='pl-4'>You are currently logged into Instructor View</span>
                        </div>
                    </div>
                    : null}
                <div className='mb-3 mx-3 d-flex justify-content-between align-items-center'>
                    <Grid container spacing={2}>

                        {this.state.isInstructor ? (
                            this.state.isStudentMode ?
                                <Grid item md={4} sm={12}>
                                    <Typography variant='h4' fontWeight={'500'}>Welcome {this.appProperties?.currentUserData?.GivenName}!</Typography>
                                    <Typography variant='subtitle' color={'primary'} fontWeight={'medium'}>Let's get you caught up!</Typography>
                                </Grid>
                                : null
                        ) :
                            <React.Fragment>
                                <Grid item md={4} sm={12}>
                                    <Typography variant='h4' fontWeight={'500'}>Welcome {this.appProperties?.currentUserData?.GivenName}!</Typography>
                                    <Typography variant='subtitle' color={'primary'} fontWeight={'medium'}>Let's get you caught up!</Typography>
                                </Grid>
                                {this.context.isSpecialCourse ?
                                    <Grid item md={4} sm={12}>
                                        <div className='w-full d-flex justify-content-center mt-2'>
                                            <SFPublicSkillsLibrary 
                                                show={this.state.showSkillsLibrary}
                                            />
                                        </div>
                                    </Grid>
                                    : null}
                            </React.Fragment>
                        }

                        {this.state.isInstructor && !this.state.isStudentMode ?
                            <React.Fragment>
                                <Grid item md={2}>
                                    <FormControl variant="standard" sx={{ m: 1, width: "100%" }}>
                                        <InputLabel id="demo-simple-select-standard-label">All Courses</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            onChange={this.handleCourseSelect}
                                            value={this.state.selectedInstructorCourse ? this.state.selectedInstructorCourse.course_id : -1}
                                            label="All Courses"
                                        >
                                            {this.state.instructorCourses?.map(course => {
                                                return <MenuItem value={course.course_id}>{course.course_name}</MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item md={2}>
                                    <FormControl sx={{ m: 1, width: "100%" }}>
                                        <InputLabel id="inst-sections">Sections</InputLabel>
                                        <Select
                                            labelId="inst-sections"
                                            id="inst-sections-id"
                                            onChange={(event) => {
                                                let courseID = this.state.selectedInstructorCourse.course_id;
                                                let sectionID = event.target.value;

                                                let course = this.state.instructorCourses.find(c => c.course_id === courseID);
                                                let section = this.state.instructorSections.find(s => s.section_id === sectionID);
                                                console.debug("section>>??", section)
                                                let tempSelectedCourse = {
                                                    ...course,
                                                    ...section,
                                                    enable_practice_and_performance: section.enable_practice_and_performance,
                                                };
                                                console.debug("tempSelectedCourse>>??", tempSelectedCourse)
                                                this.setState({
                                                    selectedInstructorSectionID: sectionID,
                                                    selectedStudentUserName: null,
                                                    selectedStudentFullName: null,
                                                    selectedInstructorCourse: tempSelectedCourse,
                                                    instructorStudents: [],
                                                })
                                                this.getInstructorCourseSectionStudents(courseID, sectionID);
                                            }}
                                            value={this.state.selectedInstructorSectionID}
                                            label="Sections"
                                        >
                                            {this.state.instructorSections?.map(section => {
                                                return <MenuItem key={section.section_id} value={section.section_id}>{section.section_name}</MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                {this.state.selectedInstructorSectionID ?
                                    <Grid item md={5}>
                                        <SFStudentSearch
                                            hideSelectAll={true}
                                            students={this.state.instructorStudents}
                                            selectedStudentUserName={this.state.selectedStudentUserName}
                                            selectedStudentFullName={this.state.selectedStudentFullName}
                                            handleStudentSelect={(userName, fullName) => {
                                                this.setState({
                                                    selectedStudentUserName: userName,
                                                    selectedStudentFullName: fullName
                                                })
                                            }}
                                        />
                                    </Grid>
                                    : null}
                            </React.Fragment>
                            : null}
                        {/*  <Grid item md={6} sm={12}>
                            <Box display="flex" justifyContent="flex-end">
                                <IconButton color='primary'>
                                    <FaCartShopping />
                                </IconButton>
                            </Box>
                        </Grid> */}
                        {/* {this.state.courses && this.state.courses.length > 1 ?
                            <Grid item md={6} sm={10} className='w-100 d-flex justify-content-end d-none'>
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 250 }}>
                                    <InputLabel id="demo-simple-select-standard-label">All Courses</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        onChange={this.handleCourseSelect}
                                        value={this.state.selectedCourse ? this.state.selectedCourse.course_id : -1}
                                        label="All Courses"
                                    >
                                        {courses?.map(course => {
                                            return <MenuItem value={course.course_id}>{course.course_name}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            : null} */}
                    </Grid>
                </div >
                <ActionResultPopup
                    icon={<CheckCircleIcon style={{ fontSize: '4rem', color: 'green' }} />}
                    title="You are now enrolled in"
                    subtitle={(
                        <div>
                            <Typography variant="h6" className="mt-2">
                                <span style={{ fontWeight: 'bold' }}>Course</span>: {this.state.selectedCourseEnrollName}
                            </Typography>
                            <Typography variant="h6" className="mt-1">
                                <span style={{ fontWeight: 'bold' }}>Section</span>: {this.state.selectedSectionEnrollName}
                            </Typography>
                        </div>
                    )}
                    description="To enrol in more courses click on your Name (Upper right hand corner) and go to Settings"
                    onClose={this.handleCloseActionResultPopup}
                    isOpen={this.state.isActionResultPopupOpen}
                />
                {this.appProperties && this.appProperties.isLTIStudent ? null :
                    <SFCourseSectionEnrollDialog
                        open={this.state.courses && this.state.courses.length === 0}
                        onMappingComplete={(courseName, sectionName) => {
                            this.getStudentCourses();
                            this.setState({
                                isActionResultPopupOpen: true, // Show the success popup
                                selectedCourseEnrollName: courseName,
                                selectedSectionEnrollName: sectionName,
                            })
                        }}
                        showCancelBtn={false}
                    />
                }
                {/* {this.appProperties && this.appProperties.isLTIStudent ? null :
                    (this.state.courses && this.state.courses.length === 0 ? (
                        <div style={{

                        }} className='mt-5'>
                            <Dialog open={this.state.showCourseEnroll && !this.state.isInstructor} maxWidth='sm' disablePortal fullWidth
                                PaperProps={{
                                    sx: {
                                        height: 400
                                    }
                                }}
                            >

                                <DialogTitle>
                                    <Typography variant='h5' color='primary' fontWeight='500' className='mb-2'>Course-Section Enrollment</Typography>
                                    Enroll in a course to start seeing your assignments.
                                </DialogTitle>
                                <div className='mx-4'>
                                    <FormControl fullWidth>
                                        <label>
                                            <b>Step 1:</b> Choose a Course:
                                        </label>
                                        <Select
                                            displayEmpty
                                            labelId="course-select"
                                            id="course-select"
                                            renderValue={(value) => {
                                                if (!value) {
                                                    return <Typography color="gray">Select</Typography>;
                                                }
                                                let course = this.state.allCourses.find(c => c.course_id === value);
                                                return course.course_name;
                                            }}
                                            value={this.state.selectedCourseEnroll ? this.state.selectedCourseEnroll : ''}
                                            onChange={(event) => {
                                                let courseID = event.target.value;
                                                this.setState({
                                                    selectedCourseEnroll: courseID,
                                                    selectedSectionEnroll: null,
                                                    selectedCourseEnrollName: this.state.allCourses.find(ac => ac.course_id === courseID)?.course_name
                                                })
                                                this.getSections(courseID)
                                            }}
                                        >
                                            {this.state.allCourses?.filter(ac => !ac.is_lti_enabled).map(ac => {
                                                return <MenuItem key={ac.course_id} value={ac.course_id}>{ac.course_name}</MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth className='mt-3'>
                                        <label>
                                            <b>Step 2:</b> Choose a Section:
                                        </label>
                                        <Select
                                            labelId="section-select"
                                            id="section-select"
                                            onChange={(event) => {
                                                let sectionID = event.target.value;
                                                this.setState({
                                                    selectedSectionEnroll: sectionID,
                                                    selectedSectionEnrollName: this.state.sections.find(s => s.section_id === sectionID)?.section_name
                                                })
                                            }}
                                            displayEmpty
                                            renderValue={(value) => {
                                                if (!value) {
                                                    return <Typography color="gray">Select</Typography>;
                                                }
                                                let section = this.state.sections.find(s => s.section_id === value);
                                                return section.section_name;
                                            }}
                                            value={this.state.selectedSectionEnroll ? this.state.selectedSectionEnroll : ''}
                                        >
                                            {this.state.sections?.map(sec => {
                                                return <MenuItem key={sec.section_id} value={sec.section_id}>{sec.section_name}</MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                    <div className='mt-4 d-flex justify-content-end align-items-end' style={{
                                        gap: '8px'
                                    }}>
                                        <Button variant='contained'
                                            style={{ width: '105px' }}
                                            disabled={this.state.selectedCourseEnroll === null || this.state.selectedSectionEnroll === null}
                                            onClick={() => {
                                                let payload = {
                                                    course_id: this.state.selectedCourseEnroll,
                                                    section_id: this.state.selectedSectionEnroll
                                                }
                                                this.addMappingService(payload)
                                            }}>
                                            {this.state.loadingEnroll ?
                                                <BeatLoader
                                                    size={8}
                                                    color={"#fff"}
                                                />
                                                : "Enroll Now"
                                            }
                                        </Button>
                                    </div>
                                </div>
                            </Dialog>
                        </div>
                    ) : null)
                } */}



                <div style={{
                    width: '100%',
                    display: this.state.isInstructor && !this.state.isStudentMode && (this.state.selectedInstructorCourse === null || this.state.selectedInstructorSectionID === null || this.state.selectedStudentUserName === null) ? "none" : "block",
                }} >
                    <ResponsiveReactGridLayout
                        style={{
                            visibility: layouts === null || layouts === undefined || layouts?.length === 0 ? 'hidden' : 'visible',
                        }}
                        /* layouts={{
                            lg: this.state.layouts.filter(lay => {
                                if (lay.i === "recommend-for-practice") {
                                    if (selectedCourse && selectedCourse !== null && selectedCourse !== undefined && selectedCourse?.enable_practice_and_performance === 2) {
                                        return true
                                    }
                                    return false
                                }
                                return true
                            })
                        }} */
                        layouts={{
                            lg: layouts
                        }}
                        className="layout"
                        isDraggable={true}
                        measureBeforeMount={false}
                        isResizable={false}
                        draggableHandle='.drag-handle'
                        isDroppable
                        margin={[16, 20]}

                    >
                        {/* Due Assignment Widget */}
                        {(this.appProperties && this.appProperties.isLTIStudent) || (this.context.isSpecialCourse) ? null :
                            <div className='bg-white' key={"assignment-due-card"} style={{ borderRadius: '2px' }}>
                                <DueAssignmentWidget
                                    {...this.props}
                                    course={this.state.selectedStudentUserName ? this.state.selectedInstructorCourse : selectedCourse}
                                    selectedStudentUserName={this.state.selectedStudentUserName}
                                />
                            </div>
                        }



                        {/* Assignments List Widget  */}
                        {(this.appProperties && this.appProperties.isLTIStudent) || (this.context.isSpecialCourse) ? null :
                            <div className='bg-white' key={"assignments-card"} style={{ borderRadius: '2px' }}>
                                <AssignmentListWidget
                                    {...this.props}
                                    course={this.state.selectedStudentUserName ? this.state.selectedInstructorCourse : selectedCourse}
                                    selectedStudentUserName={this.state.selectedStudentUserName}
                                />
                            </div>
                        }

                        {(this.context.isSpecialCourse) ?
                            <div className='bg-white' key={"skills-widget"} style={{ borderRadius: '2px' }}>
                                <SkillsWidget
                                    {...this.props}
                                    onNoData={() => {
                                        // then show up the popup of skills library
                                        this.setState({ showSkillsLibrary: true });
                                    }}
                                />
                            </div>
                            : null}


                        {/* Recommended for practice  */}
                        {courseToUse && courseToUse.enable_practice_and_performance === 2 ? (
                            <div
                                className="bg-white"
                                key="recommend-for-practice"
                                style={{ borderRadius: "2px" }}
                            >

                                {grayedOut ? (
                                    this.getSteps(courseToUse, cpanelCourseUrl)
                                ) : null}

                                <span className={`${grayedOut ? 'blur-filter' : ''}`}>
                                    <RecommendForPracticeWidget
                                        {...this.props}
                                        course={courseToUse}
                                        selectedStudentUserName={this.state.selectedStudentUserName}
                                    />
                                </span>
                            </div>
                        ) : null}



                        {/* Performance Widget */}
                        {courseToUse && courseToUse.enable_practice_and_performance === 2 ? (
                            <div
                                className="bg-white"
                                key="performance-widget"
                                style={{ borderRadius: "2px" }}
                            >
                                {grayedOut ? (
                                    this.getSteps(courseToUse, cpanelCourseUrl)
                                ) : null}
                                <span className={`${grayedOut ? 'blur-filter' : ''}`}>
                                    <PerformanceWidget
                                        {...this.props}
                                        selectedCourse={courseToUse}
                                        selectedStudentUserName={this.state.selectedStudentUserName}
                                    />
                                </span>
                            </div>
                        ) : null}



                        {/* Practice Widget */}
                        {courseToUse && courseToUse.enable_practice_and_performance === 2 ? (
                            <div
                                className="bg-white"
                                key="practice-widget"
                                style={{ borderRadius: "2px" }}
                            >
                                {grayedOut ? (
                                    this.getSteps(courseToUse, cpanelCourseUrl)
                                ) : null}
                                <span className={`${grayedOut ? 'blur-filter' : ''}`}>
                                    <PracticeSetsWidget
                                        key="practice-widget"
                                        newPracticeAssignment={this.state.newPracticeAssignment}
                                        selectedCourse={courseToUse}
                                        selectedStudentUserName={this.state.selectedStudentUserName}
                                        {...this.props}
                                    />
                                </span>
                            </div>
                        ) : null}



                    </ResponsiveReactGridLayout>
                </div>

                {
                    selectedCourse && selectedCourse.enable_practice_and_performance !== 0 ?
                        <SFPracticeSetCart
                            handleRemoveCategory={handleRemoveCategory}
                            handleClearCart={this.handleClearCart}
                            selectedCategories={selectedCategories}
                            handleRoute={this.props.handleRoute}
                            onAddActivityLog={onAddActivityLog}
                            onSavePracticeSet={this.onSavePracticeSet}
                        />
                        : null
                }
            </div >
        )
    }
}

export default SFDashboard;


